import React, { useState, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { resetPassword } from '../service/PasswordResetService';
import './Login.scss';

const ResetPassword = () => {
    const toast = useRef(null);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';

    const [password, setPassword] = useState('');
    const [confirmacion, setConfirmacion] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const showError = (detail) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail, life: 4000 });
    };

    const handleGuardar = async () => {
        if (!token) { showError('El link no es válido. Pedí uno nuevo desde "¿Olvidaste tu contraseña?"'); return; }
        if (!password || password.length < 6) { showError('La contraseña debe tener al menos 6 caracteres'); return; }
        if (password !== confirmacion) { showError('Las contraseñas no coinciden'); return; }

        setSubmitting(true);
        try {
            await resetPassword(token, password);
            toast.current.show({ severity: 'success', summary: 'Listo', detail: 'Contraseña actualizada correctamente', life: 3000 });
            setTimeout(() => navigate('/login'), 1500);
        } catch (err) {
            showError(err.response?.data?.errorDisplay || 'El link es inválido o expiró');
        } finally {
            setSubmitting(false);
        }
    };

    const handleKeyUpEnter = (e) => {
        if (e.key === 'Enter') handleGuardar();
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="ef-login">
                <div className="ef-login-visual">
                    <img className="ef-login-bg" src="assets/layout/images/pages/login.jpg" alt="" />
                    <div className="ef-login-overlay"></div>

                    <div className="ef-login-brand">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                            <path d="M3 12L12 4L21 12" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 11V20H18V11" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span>EXPENSAS<b>360</b></span>
                    </div>

                    <div className="ef-login-headline">
                        <h1>Todo tu barrio,<br />en un solo panel.</h1>
                        <p>Gestioná expensas, pagos y comunicación con tus vecinos de forma simple, desde cualquier lugar.</p>
                    </div>
                </div>

                <div className="ef-login-panel">
                    <div className="ef-login-panel-inner">
                        <img className="ef-login-logo" src="./assets/layout/images/ab/expensas360.png" alt="Expensas360" />

                        <h2 className="ef-login-title">Definir nueva contraseña</h2>
                        <p className="ef-login-subtitle">Ingresá tu nueva contraseña</p>

                        <div className="ef-login-field">
                            <label htmlFor="password">Nueva contraseña</label>
                            <div className="ef-login-input-wrap">
                                <InputText
                                    id="password"
                                    type="password"
                                    className="ef-login-input"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    onKeyUp={handleKeyUpEnter}
                                />
                            </div>
                        </div>

                        <div className="ef-login-field">
                            <label htmlFor="confirmacion">Confirmar contraseña</label>
                            <div className="ef-login-input-wrap">
                                <InputText
                                    id="confirmacion"
                                    type="password"
                                    className="ef-login-input"
                                    value={confirmacion}
                                    onChange={e => setConfirmacion(e.target.value)}
                                    onKeyUp={handleKeyUpEnter}
                                />
                            </div>
                        </div>

                        <Button
                            type="button"
                            label="Guardar nueva contraseña"
                            className="ef-login-submit"
                            loading={submitting}
                            onClick={handleGuardar}
                        />

                        <p className="ef-login-signup">
                            <button type="button" className="ef-login-link" onClick={() => navigate('/login')}>Volver a iniciar sesión</button>
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
